enum RelationType {
  Contact = 'Contact',
  Company = 'Company',
  Team = 'Team',
}

export default RelationType;
